export type Position = [number, number, number];
export const SPARKLE_POSITIONS: Position[] = [
    [
        358,
        85,
        -311
    ],
    [
        -350,
        7,
        -348
    ],
    [
        -328,
        85,
        -368
    ],
    [
        230,
        -160,
        -378
    ],
    [
        248,
        176,
        -329
    ],
    [
        351,
        153,
        -367
    ],
    [
        -430,
        193,
        -368
    ],
    [
        -395,
        -55,
        -326
    ],
    [
        86,
        138,
        -330
    ],
    [
        -30,
        120,
        -368
    ],
    [
        -165,
        214,
        -339
    ],
    [
        324,
        206,
        -306
    ],
    [
        406,
        -170,
        -388
    ],
    [
        -320,
        -161,
        -341
    ],
    [
        -405,
        -120,
        -379
    ],
    [
        33,
        211,
        -316
    ],
    [
        121,
        -206,
        -397
    ],
    [
        292,
        -108,
        -348
    ],
    [
        -132,
        145,
        -320
    ],
    [
        -260,
        -200,
        -398
    ]
]